/*
NAMING NEW COLOURS (Repeatable Naming Standard)

Hue Name + Lightness Value

Find Name -- https://chir.ag/projects/name-that-color
Find Lightness Value - https://colordesigner.io/convert/hextohsv
*/

// Red
export const cardinal77 = '#c5192d';
export const cardinal82 = '#d02239';
export const cardinal83 = '#d41f3a';
export const disco64 = '#a21942';

// Orange
export const tangerine95 = '#f39200';

// Yellow
export const lightningYellow98 = '#fac322';
export const marigold75 = '#bf8b2e';
export const corn92 = '#eac80c';

// Green
export const goblin49 = '#3f7e44';
export const seaGreen58 = '#37954a';
export const japaneseLaurel46 = '#207600';
export const forestGreen56 = '#1e9022';

// Blue
export const allports58 = '#007495';
export const java77 = '#1bbbc5';
export const easternBlue68 = '#1b8fae';

// Purple
export const finn42 = '#6a2e5e';

// Grey
export const alabaster97 = '#f7f7f7';
export const codGray10 = '#191919';
export const concrete95 = '#f2f2f2';
export const gray50 = '#7f7f7f';
export const mercury90 = '#e5e5e5';
export const scorpion35 = '#595959';
export const silverChalice70 = '#b2b2b2';
export const tundora30 = '#4c4c4c';

// Brand Colours
export const cefRed = cardinal82;
export const cefBlack = '#000';
export const cefWhite = '#fff';

// Main Text Colours
export const mainTextColor = codGray10;
export const secondaryTextColor = scorpion35;

// Background & Secondary Colours
export const grey5 = concrete95;
export const grey10 = mercury90;
export const grey30 = silverChalice70;
export const grey50 = gray50;
export const grey70 = tundora30;

// Call to Action
export const ctaGreen = japaneseLaurel46;

// Alerts & Warnings
export const success = forestGreen56;
export const information = corn92;
export const error = cardinal83;

// Promotional Colours
export const cefPromoOrange = tangerine95;
export const cefPromoTeal = allports58;
export const cefPromoPurple = finn42;
export const cefPromoGreen = seaGreen58;

// Primary Fonts
export const headingFont = 'Roboto Condensed, Arial, Helvetica, sans-serif';
export const bodyFont = 'Roboto, Arial, Helvetica, sans-serif';
